import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        py: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Designed and Developed by{" "}
        <Link
          href="https://nitrosolutions.co.uk/"
          color="error"
          underline="hover"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            minHeight: 44,
          }}
        >
          Nitro Solutions
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
